import type { SiteSeoProfile } from "@modes0/ui-components-seo";
import {
    BUSINESS_NAME,
    WEBSITE_URL,
    businessDetails,
    contactDetails,
    defaultMetaTags,
    googleDetails,
    socialMediaProfiles,
} from "@/content/business-details/business-content";

const sameAs = [
    socialMediaProfiles.facebookHandle &&
        `${socialMediaProfiles.facebookLink}${socialMediaProfiles.facebookHandle}`,
    socialMediaProfiles.instaHandle &&
        `${socialMediaProfiles.instaLink}${socialMediaProfiles.instaHandle}`,
    socialMediaProfiles.linkedInHandle &&
        `${socialMediaProfiles.linkedInLink}${socialMediaProfiles.linkedInHandle}`,
    socialMediaProfiles.youTubeHandle &&
        `${socialMediaProfiles.youTubeLink}${socialMediaProfiles.youTubeHandle}`,
    googleDetails.googleLink,
].filter(Boolean) as string[];

export const seoSiteProfile: SiteSeoProfile = {
    siteUrl: WEBSITE_URL,
    siteName: BUSINESS_NAME,
    language: "en-AU",
    defaultMeta: defaultMetaTags,
    defaultImage: "/images/parallax/pllx-1.webp",
    faviconHref: "/images/favicon/favicon.ico",
    organization: {
        name: BUSINESS_NAME,
        url: WEBSITE_URL,
        logo: businessDetails.branding.headerLogoUrl,
        sameAs,
    },
    localBusiness: {
        schemaType: ["SecurityService", "ProfessionalService", "LocalBusiness"],
        name: BUSINESS_NAME,
        description: defaultMetaTags.description,
        url: WEBSITE_URL,
        image: [defaultMetaTags.ogImage, "/images/parallax/pllx-1.webp"],
        logo: businessDetails.branding.headerLogoUrl,
        telephone: contactDetails.contactNumberOne,
        email: contactDetails.contactEmail,
        taxId: businessDetails.companyData.abn,
        taxIdLabel: "ABN",
        address: businessDetails.address,
        geo: googleDetails.serviceAreaLatLong,
        areaServed: [
            googleDetails.areaServed
                ? { type: "AdministrativeArea", name: googleDetails.areaServed }
                : undefined,
            ...businessDetails.serviceAreas,
        ].filter(Boolean) as NonNullable<SiteSeoProfile["localBusiness"]>["areaServed"],
        serviceAreaRadius: 40000,
        currenciesAccepted: "AUD",
        contactPoint: {
            telephone: contactDetails.contactNumberOne,
            email: contactDetails.contactEmail,
            contactType: "customer service",
            areaServed: "AU",
            availableLanguage: "en-AU",
        },
        knowsAbout: [
            "CCTV installation",
                  "CCTV maintenance",
                  "Alarm systems",
                  "Intercom systems",
                  "Access control systems",
                  "Automatic security gates",
                  "Security guards",
                  "Mobile patrols",
                  "Security consultation",
                  "Fire alarm systems",
                  "Security cabling",
        ],
        sameAs,
    },
};
